import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScPool = styled.div`
  padding: 12px 12px 12px 24px;
  gap: 8px;
  position: relative;
  background: ${({ theme }) => theme.whiteColor};
  border-radius: 12px;

  & > .pool-icon {
    position: absolute;
    top: -12px;
    right: 8px;
    width: 88px;
    height: 88px;
  }

  & > .title {
    font-size: 16px;
    line-height: 1.25;
    letter-spacing: 0.01em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.blackColor};
    font-weight: bold;
  }

  & > .prize {
    font-size: 32px;
    line-height: 1.25;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.blackColor};
    font-weight: bold;
  }

  & > .details {
    margin-top: 12px;
    font-size: 12px;
    line-height: 1.5;
    color: ${({ theme }) => theme.grayColor};
    display: flex;
    column-gap: 16px;
    row-gap: 4px;
    flex-wrap: wrap;

    div {
      display: flex;
      gap: 8px;
      align-items: center;
    }
  }

  @media (${device.mobile}) {
    & > .prize {
      font-size: 28px;
      line-height: 1.29;
    }
  }
`;
